<div class="contact-us">
  <div class="mx-auto">
    <div class="heading">Contact us</div>
    <div class="content">
        <p>Please address all questions/comments to:<br />
            HSR, Client Relations [<a href="mailto:ClientRelations@hsri.com">Attn: Cassandra</a>]</p>
    </div>
    <div class="phone">
        <p>
            <img src="./assets/images/phone.svg" alt="Unable to load image">
        <span class="text">Make a phone call</span> <span class="phone-number"> : (866) 345-2680</span></p>
    </div>
  </div>
</div>
